import React, { Component } from 'react';
// import ReactDOM from "react-dom";
import { connect } from 'react-redux';
// import * as Contracts from '../../Store/Contracts';
import * as ContractCheck from './Saga/ContractCheck';
import Button from '@material-ui/core/Button';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import NetworkWifiIcon from '@material-ui/icons/NetworkWifi';
import RouterIcon from '@material-ui/icons/Router';
import KitchenIcon from '@material-ui/icons/Kitchen';
import CallIcon from '@material-ui/icons/Call';
import FaceIcon from '@material-ui/icons/Face';
import Brightness5Icon from '@material-ui/icons/Brightness5';
import BuildIcon from '@material-ui/icons/Build';
import UpdateIcon from '@material-ui/icons/Update';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Table, Column, Cell } from 'fixed-data-table-2';
import 'fixed-data-table-2/dist/fixed-data-table.css';

// import HandymanIcon from '@mui/icons-material/Handyman';
import './Css/Grid.css';
import moment from 'moment'

const ReactDataGrid = require('react-data-grid');
interface Props {
  // get_banks: any,
  rent_contracts_check_list: [],
  shops: any,
  parking_checked: any,
  parking_check_loading: number,
  energization_checked: any,
  energization_check_loading: number,
  net_checked: any,
  net_check_loading: number,

  electronics_checked: any,
  electronics_check_loading: number,

  wifi_checked: any,
  wifi_check_loading: number,
  autolock_checked: any,
  autolock_check_loading: number,
  completed_checked: any,

  owner_tel_check_loading: number,
  owner_tel_checked: any,
  rent_contract_logs: any,
  get_rent_contract_logs: any,
  check_rent_contract_logs: any,
  // columns:[],

}



interface State {
  columns: any
  refresh: boolean
  open_change_flg: boolean
  rent_contract_id: number
  confirm: boolean
  columnWidths: any
  // state types
}


const DateFormatter = (payload: any) => {
  if (payload.value) {
    return moment(payload.value).format("YYYY/MM/DD");
  } else {
    return "";
  }
};
const nameFormatter = (payload: any) => {
  if (payload.row.name2) {
    return <div><div>{payload.row.name1}</div><div style={{ fontSize: "10px" }} >{payload.row.name2}</div ></div >
  } else {
    return payload.row.name1;
  }
};

const netFormatter = (payload: any) => {
  // if (payload.value && payload.row.is_globalnet) {
  if (payload.value) {
    return <div style={{ marginLeft: "10px" }}>{payload.value}</div >

  } else {
    return <div style={{ background: payload.row.is_cancel === 1 ? "pink" : payload.row.counting === 2 ? "#f5f5f5" : "#CCC", height: "100px" }}>　</div >
  }
};

const netkoujiFormatter = (payload: any) => {
  return ""
  // if (payload.value && payload.row.is_globalnet) {
  // if (payload.value) {
  //   return <div style={{ marginLeft: "10px" }}>{payload.value}</div >

  // } else {
  //   return <div style={{ background: payload.row.is_cancel === 1 ? "pink" : payload.row.counting === 2 ? "#f5f5f5" : "#CCC", height: "100px" }}>　</div >
  // }
};

const parkingFormatter = (payload: any) => {
  if (payload.value && payload.row.counting === 1) {
    return ""

  } else {
    return <div style={{ background: payload.row.is_cancel === 1 ? "pink" : payload.row.counting === 2 ? "#f5f5f5" : "#CCC", height: "100px" }}>　</div >
  }
};
const electronicsFormatter = (payload: any) => {
  if (payload.value) {
    return ""

  } else {
    return <div style={{ background: payload.row.is_cancel === 1 ? "pink" : payload.row.counting === 2 ? "#f5f5f5" : "#CCC", height: "100px" }}>　</div >
  }
};


const energizationFormatter = (payload: any) => {
  if (payload.value) {
    return ""

  } else {
    return <div style={{ background: payload.row.is_cancel === 1 ? "pink" : payload.row.counting === 2 ? "#f5f5f5" : "#CCC", height: "100px" }}>　</div >
  }
};

const wifiFormatter = (payload: any) => {
  // if (payload.value !== 2 && payload.row.net && (parseInt(payload.row.net_gyosha_no) === 1 || parseInt(payload.row.net_gyosha_no) === 2 || parseInt(payload.row.net_gyosha_no) === 368)) {
  if (payload.value !== 1) {
    return ""

  } else {

    return <div style={{ background: payload.row.is_cancel === 1 ? "pink" : payload.row.counting === 2 ? "#f5f5f5" : "#CCC", height: "100px" }}>　</div >
  }
};

const autolockTargetTatemonoIds = [873, 2109];

const autolockFormatter = (payload: any) => {
  if (autolockTargetTatemonoIds.indexOf(parseInt(payload.row.tatemono_id)) !== -1) {
    return ""
  } else {
    return <div style={{ background: payload.row.is_cancel === 1 ? "pink" : payload.row.counting === 2 ? "#f5f5f5" : "#CCC", height: "100px" }}>　</div >
  }
};


const ownerFormatter = (payload: any) => {
  if (payload.row.counting === 2) {
    return ""

  } else {

    return <div style={{ background: payload.row.is_cancel === 1 ? "pink" : payload.row.counting === 2 ? "#f5f5f5" : "#CCC", height: "100px" }}>　</div >
  }
};


const changecontentsFormatter = (payload: any) => {
  if (!payload.row.change_contents) {
    return ""

  } else {

    return <div style={{ background: payload.row.is_cancel === 1 ? "pink" : payload.row.counting === 2 ? "#f5f5f5" : "#CCC", height: "100px" }}>　</div >
  }
};

// const SelectFormatter =(payload:any) => {
//   console.log(payload)
//   if(payload.row.receipt_at && payload.row.payment_at){
//     // return moment(payload.value).format("YYYY/MM/DD");
//     return <div>　</div>
//   }else{
//     return <div  style={{background:"#CCC"}}>　</div>;
//   }
//   };


const RowRenderer = ({ renderBaseRow, ...props }: any) => {
  //console.log(props)
  //const color = props.idx % 2 ? "green" : "blue";

  let backgroundColor = ""
  if (props.row.is_cancel === 1) {
    backgroundColor = " row-highlight-pink";
  } else if (props.row.change_send_pm_flg === 1) {

    backgroundColor = " row-highlight-yellowgreen";
  } else if (props.row.counting === 2) {
    backgroundColor = " row-highlight-smoke";
  }

  //divだと描画が震える　.border-bottoms>div>div 　アンダーバーは←のように指定
  return <span className={backgroundColor}>{renderBaseRow(props)}</span>;



};

// const rows = [
//   "first row",
//   "second row",
//   "third row"
//   // .... and more
// ];

// Custom cell implementation with special prop
const MyCustomCell = ({ mySpecialProp }: any) =>
  <Cell>
    {mySpecialProp === "column2" ? "I'm column 2" : "I'm not column 2"}
  </Cell>;



const defaultColumnProperties = {
  sortable: true,
  // width: 120
};

/**
 *会計連動グリッド
 *
 * @class AccountingGridComponent
 * @extends {Component<Props, State>}
 */
class AccountingGridComponent extends Component<Props, State> {
  constructor(props: Readonly<Props>) {
    super(props);
    this.onRowClick = this.onRowClick.bind(this);

    this.state = {
      refresh: false,
      open_change_flg: false,
      rent_contract_id: 0,
      confirm: false,
      columnWidths: {
        column1: 400,
        column2: 200,
        column3: 80,
      },
      columns: [
        { key: 'bind', name: '詳細', width: 60, resizable: true },
        { key: 'confirm_manager_at', name: '承認日', width: 100, resizable: true, formatter: DateFormatter },
        { key: 'contract_date', name: '契約日', width: 100, resizable: true, formatter: DateFormatter },

        { key: 'name1', name: '契約者名', width: 150, resizable: true, formatter: nameFormatter },

        { key: 'Tenpo_Name', name: '店舗', width: 80, resizable: true },
        { key: 'user_name', name: '担当', width: 50, resizable: true },

        // { key: 'amount', name: '金額', width: 80,resizable: true },

        // { key: 'pay_way', name: '支払方法', width: 80,resizable: true },
        // { key: 'tatemonoAddress1', name: '建物住所', width: 100,resizable: true },
        { key: 'building_name', name: '建物名', width: 150, resizable: true },
        { key: 'room_name', name: '部屋名', width: 60, resizable: true },
        // { key: 'minori', name: 'みのり', width: 60, resizable: true },
        // { key: 'completion_at', name: '完工日', width: 80, resizable: true },
        // { key: 'Kouji_Gyousha', name: '業者', width: 60, resizable: true },

        { key: 'electronics', name: '家電', width: 60, resizable: true, formatter: electronicsFormatter },
        { key: 'parking', name: '駐車場', width: 60, resizable: true, formatter: parkingFormatter },
        { key: 'net', name: 'ネット', width: 150, resizable: true, formatter: netFormatter },
        { key: 'net_kouji', name: 'ネット工事', width: 80, resizable: true, formatter: netkoujiFormatter },

        { key: 'wifi', name: 'wifi', width: 60, resizable: true, formatter: wifiFormatter },
        { key: 'autolock', name: 'AL', width: 60, resizable: true, formatter: autolockFormatter },

        { key: 'energization', name: '通電', width: 60, resizable: true, formatter: energizationFormatter },
        { key: 'is_energization_gyousha', name: '通電会社', width: 80, resizable: true },
        { key: 'owner_tel', name: '家主TEL', width: 60, resizable: true, formatter: ownerFormatter },
        // { key: 'is_cancel', name: 'キャンセル', width: 60, resizable: true },
        { key: 'cahnge_contents', name: '変更', width: 80, resizable: true, formatter: changecontentsFormatter },
        { key: 'office_check_completed', name: '消込', width: 60, resizable: true },
        // {key: 'start_at', name: '始期日', width: 80, resizable: true, formatter: DateFormatter },
        // { key: 'end_at', name: '終了日',width: 80, resizable: true, formatter: DateFormatter },
        // { key: 'receipt_at', name: '領収日',width: 80, resizable: true, formatter: DateFormatter },
        // { key: 'payment_at', name: '入金日',width: 80, resizable: true, formatter: DateFormatter},

        // { key: 'rent_contract_name1', name: '契約者名',width: 80, resizable: true},
        // { key: 'rent_contract_tatemono_name', name: '建物名',width: 100, resizable: true},
        // { key: 'rent_contract_room_name', name: '部屋名',width: 60, resizable: true},
        // { key: 'contract_money', name: '契約金',width: 60, resizable: true },

        // { key: 'accounting_output_at', name: '出力日',width: 100, resizable: true },

      ].map(c => ({ ...c, ...defaultColumnProperties }))
    };

    this.sortRows = this.sortRows.bind(this);
    this.SectionFormatter = this.SectionFormatter.bind(this);
    this.getCellActions = this.getCellActions.bind(this);
    this.getRowCount = this.getRowCount.bind(this);

    this.open_change = this.open_change.bind(this);
    this.check_rent_contract_logs_set = this.check_rent_contract_logs_set.bind(this);
    this._onColumnResizeEndCallback = this._onColumnResizeEndCallback.bind(this);

  }





  SectionFormatter = (payload: any) => {

    const result = this.props.shops.filter((x: any) => x.tenpoNo === payload.value);

    return result[0].tenpoName;

  };


  componentWillMount() {

    // this.props.get_banks({output:true,name:"",date1:"",date2:""})


  }
  getSelectedCell(event: any) {
    alert()
  }

  onRowClick = (rowIdx: any, row: any) => {




  }


  // rowGetter = (i:number) => {
  //     return this.props.rent_contracts_list[i];
  //   };

  onRowsSelected = (rows: any) => {
    console.log(rows)
    rows.forEach(function (r: any) {
      r.row.selected = true;
    });

    this.forceUpdate();

  };

  onRowsDeselected = (rows: any) => {

    rows.forEach(function (r: any) {
      r.row.selected = false;
    });
    this.forceUpdate();
  };


  open_change = (rows: any) => {

    this.props.get_rent_contract_logs(rows.id)
    // alert(rows.change_confirm_pm_at)

    this.setState({ open_change_flg: true, rent_contract_id: rows.id, confirm: rows.change_send_pm_flg === 1 ? true : false })
  };
  close_change = () => {
    this.setState({ open_change_flg: false, rent_contract_id: 0, confirm: false })
  };

  check_rent_contract_logs_set = (id: any) => {
    this.props.check_rent_contract_logs(id)

    // alert(rows.change_confirm_pm_at)

    this.setState({ open_change_flg: false, rent_contract_id: 0, confirm: false })
  };


  sortRows = (initialRows: any, sortColumn: any, sortDirection: any) => {


    const comparer = (a: any, b: any) => {
      if (sortColumn === "confirm_manager_at") {
        if (sortDirection === "ASC") {

          return new Date(a[sortColumn]) > new Date(b[sortColumn]) ? 1 : -1;
        } else if (sortDirection === "DESC") {
          return new Date(a[sortColumn]) < new Date(b[sortColumn]) ? 1 : -1;
        } else {
          return 1;
        }
      } else {

        if (sortDirection === "ASC") {

          return a[sortColumn] > b[sortColumn] ? 1 : -1;
        } else if (sortDirection === "DESC") {
          return a[sortColumn] < b[sortColumn] ? 1 : -1;
        } else {
          return 1;
        }
      }
    };


    this.setState({
      refresh: !this.state.refresh
    });
    return sortDirection === "NONE" ? initialRows : this.props.rent_contracts_check_list.sort(comparer);
  };




  getCellActions(column: any, row: any) {

    if (column.key === "bind") {
      return [{
        icon: <Button
          color="primary"
          variant="contained"
          size="small"
          type="submit"

          style={{ margin: 2, minWidth: 0, width: 50 }}
        // onClick={()=>this.add(12)}
        >詳細
        </Button>,
        callback: () => {
          window.open(`https://crmnext.homestation.jp/Contracts/?conid=${row.id}`, '_blank', 'noopener')
        }
      }]
      // } else if (column.key === "net") {
      //   if (row.net && row.office_check_net_at) {
      //     return [{
      //       icon: <Button
      //         color="primary"
      //         variant="outlined"
      //         size="small"
      //         type="submit"
      //         disabled={this.props.net_check_loading === row.id}
      //         style={{ margin: 2, minWidth: 0, width: 50, padding: 0, lineHeight: 2.4 }}
      //       // onClick={()=>this.add(12)}
      //       >

      //         {new Date(row.office_check_net_at).getMonth() + 1 + "/" + new Date(row.office_check_net_at).getDate() + " " + row.office_check_net_user_name}

      //       </Button>,
      //       callback: () => {
      //         if (this.props.net_check_loading !== row.id) {
      //           this.props.net_checked(row.id)
      //         }
      //       }

      //     }]
      //   } else if (row.net) {
      //     return [{
      //       icon: <Button
      //         color="secondary"
      //         variant="contained"
      //         size="small"
      //         type="submit"
      //         disabled={this.props.net_check_loading === row.id}
      //         style={{ margin: 2, minWidth: 0, width: 50 }}
      //       // onClick={()=>this.add(12)}
      //       ><NetworkWifiIcon />
      //       </Button>,
      //       callback: () => {
      //         if (this.props.net_check_loading !== row.id) {
      //           this.props.net_checked(row.id)
      //         }
      //       }

      //     }]
      //   }

    } else if (column.key === "electronics") {
      if (row.electronics && row.office_check_electronics_at) {
        return [{
          icon: <Button
            color="primary"
            variant="outlined"
            size="small"
            type="submit"
            disabled={this.props.electronics_check_loading === row.id}
            style={{ margin: 2, minWidth: 0, width: 50, padding: 0, lineHeight: 2.4 }}
          // onClick={()=>this.add(12)}
          >

            {new Date(row.office_check_electronics_at).getMonth() + 1 + "/" + new Date(row.office_check_electronics_at).getDate() + " " + row.office_check_electronics_user_name}

          </Button>,
          callback: () => {
            if (this.props.electronics_check_loading !== row.id) {
              this.props.electronics_checked(row.id)
            }
          }

        }]
      } else if (row.electronics) {
        return [{
          icon: <Button
            color="secondary"
            variant="contained"
            size="small"
            type="submit"
            disabled={this.props.electronics_check_loading === row.id}
            style={{ margin: 2, minWidth: 0, width: 50 }}
          // onClick={()=>this.add(12)}
          ><KitchenIcon />
          </Button>,
          callback: () => {
            if (this.props.electronics_check_loading !== row.id) {
              this.props.electronics_checked(row.id)
            }
          }

        }]
      }


    } else if (column.key === "wifi") {

      if (row.net && row.wifi === 1 && row.office_check_wifi_at) {
        return [{
          icon: <Button
            color="primary"
            variant="outlined"
            size="small"
            type="submit"
            disabled={this.props.wifi_check_loading === row.id}
            style={{ margin: 2, minWidth: 0, width: 50, padding: 0, lineHeight: 2.4 }}
          // onClick={()=>this.add(12)}
          >

            {new Date(row.office_check_wifi_at).getMonth() + 1 + "/" + new Date(row.office_check_wifi_at).getDate() + " " + row.office_check_wifi_user_name}

          </Button>,
          callback: () => {
            if (this.props.wifi_check_loading !== row.id) {
              this.props.wifi_checked(row.id)
            }
          }

        }]
      } else if (row.net && row.wifi === 1 && (parseInt(row.net_gyosha_no) === 1 || parseInt(row.net_gyosha_no) === 2 || parseInt(row.net_gyosha_no) === 368)) {
        return [{
          icon: <Button
            color="secondary"
            variant="contained"
            size="small"
            type="button"
            disabled={this.props.wifi_check_loading === row.id}
            style={{ margin: 2, minWidth: 0, width: 50 }}
          // onClick={()=>this.add(12)}
          ><RouterIcon />
          </Button>,
          callback: () => {
            if (this.props.wifi_check_loading !== row.id) {
              this.props.wifi_checked(row.id)
            }
          }

        }]
      }



    } else if (column.key === "net_kouji") {
      if (row.net && row.is_kouji_jousetsu_net) {
        return [{
          icon: <Button

            variant="outlined"
            size="small"
            type="button"
            disabled={true}
            style={{ margin: 1, minWidth: 0, width: 70 }}
          // onClick={()=>this.add(12)}
          ><div><BuildIcon style={{ fontSize: "9px" }} />工事済</div>
            {/* <HandymanIcon /> */}
          </Button>,
          callback: () => {
            // if (this.props.wifi_check_loading !== row.id) {
            //   this.props.wifi_checked(row.id)
            // }
          }

        }]
      } else if (row.net) {
        return [{
          icon: <Button
            color="secondary"
            variant="contained"
            size="small"
            type="button"
            // disabled={this.props.wifi_check_loading === row.id}
            style={{ margin: 2, minWidth: 0, width: 50 }}
          // onClick={()=>this.add(12)}
          ><BuildIcon />
          </Button>,
          callback: () => {
            // if (this.props.wifi_check_loading !== row.id) {
            //   this.props.wifi_checked(row.id)
            // }
          }

        }]
      }
    } else if (column.key === "autolock") {
      if (autolockTargetTatemonoIds.indexOf(parseInt(row.tatemono_id)) === -1) {
        return []
      }

      if (row.office_check_autolock_at) {
        return [{
          icon: <Button
            color="primary"
            variant="outlined"
            size="small"
            type="submit"
            disabled={this.props.autolock_check_loading === row.id}
            style={{ margin: 2, minWidth: 0, width: 50, padding: 0, lineHeight: 2.4 }}
          >

            {new Date(row.office_check_autolock_at).getMonth() + 1 + "/" + new Date(row.office_check_autolock_at).getDate() + " " + row.office_check_autolock_user_name}

          </Button>,
          callback: () => {
            if (this.props.autolock_check_loading !== row.id) {
              this.props.autolock_checked(row.id)
            }
          }

        }]
      } else {
        return [{
          icon: <Button
            color="secondary"
            variant="contained"
            size="small"
            type="submit"
            disabled={this.props.autolock_check_loading === row.id}
            style={{ margin: 2, minWidth: 0, width: 50 }}
          ><FaceIcon />
          </Button>,
          callback: () => {
            if (this.props.autolock_check_loading !== row.id) {
              this.props.autolock_checked(row.id)
            }
          }

        }]
      }
    } else if (column.key === "parking") {
      if ((row.parking > 0 && row.office_check_parking_at) || (row.counting === 2 && row.office_check_parking_at)) {
        return [{
          icon: <Button
            color="primary"
            variant="outlined"
            size="small"
            type="submit"
            disabled={this.props.parking_check_loading === row.id}
            style={{ margin: 2, minWidth: 0, width: 50, padding: 0, lineHeight: 2.4 }}
          // onClick={()=>this.add(12)}
          >

            {new Date(row.office_check_parking_at).getMonth() + 1 + "/" + new Date(row.office_check_parking_at).getDate() + " " + row.office_check_parking_user_name}

          </Button>,
          callback: () => {
            if (this.props.parking_check_loading !== row.id) {
              this.props.parking_checked(row.id)
            }
          }

        }]
      } else if (row.parking > 0 || row.counting === 2) {
        return [{
          icon: <Button
            color="secondary"
            variant="contained"
            size="small"
            type="submit"
            disabled={this.props.parking_check_loading === row.id}
            style={{ margin: 2, minWidth: 0, width: 50 }}
          // onClick={()=>this.add(12)}
          ><DriveEtaIcon />
          </Button>,
          callback: () => {
            if (this.props.parking_check_loading !== row.id) {
              this.props.parking_checked(row.id)
            }
          }

        }]
      }

    } else if (column.key === "energization") {
      if (row.office_check_energization_at) {
        return [{
          icon: <Button
            color="primary"
            variant="outlined"
            size="small"
            type="submit"
            disabled={this.props.energization_check_loading === row.id}
            style={{ margin: 2, minWidth: 0, width: 50, padding: 0, lineHeight: 2.4 }}
          // onClick={()=>this.add(12)}
          >

            {new Date(row.office_check_energization_at).getMonth() + 1 + "/" + new Date(row.office_check_energization_at).getDate() + " " + row.office_check_energization_user_name}

          </Button>,
          callback: () => {
            if (this.props.energization_check_loading !== row.id) {
              this.props.energization_checked(row.id)
            }
          }

        }]
      } else if (row.energization === 1) {
        return [{
          icon: <Button
            color="secondary"
            variant="contained"
            size="small"
            type="submit"
            disabled={this.props.energization_check_loading === row.id}
            style={{ margin: 2, minWidth: 0, width: 50 }}
          // onClick={()=>this.add(12)}
          ><Brightness5Icon />
          </Button>,
          callback: () => {
            if (this.props.energization_check_loading !== row.id) {
              this.props.energization_checked(row.id)
            }
          }

        }]
      }

    } else if (column.key === "owner_tel") {
      if (row.counting === 2 && row.office_check_owner_tel_at) {
        return [{
          icon: <Button
            color="primary"
            variant="outlined"
            size="small"
            type="submit"
            disabled={this.props.owner_tel_check_loading === row.id}
            style={{ margin: 2, minWidth: 0, width: 50, padding: 0, lineHeight: 2.4 }}
          // onClick={()=>this.add(12)}
          >

            {new Date(row.office_check_owner_tel_at).getMonth() + 1 + "/" + new Date(row.office_check_owner_tel_at).getDate() + " " + row.office_check_owner_tel_user_name}

          </Button>,
          callback: () => {
            if (this.props.owner_tel_check_loading !== row.id) {
              this.props.owner_tel_checked(row.id)
            }
          }

        }]
      } else if (row.counting === 2) {
        return [{
          icon: <Button
            color="secondary"
            variant="contained"
            size="small"
            type="submit"
            disabled={this.props.owner_tel_check_loading === row.id}
            style={{ margin: 2, minWidth: 0, width: 50 }}
          // onClick={()=>this.add(12)}
          ><CallIcon />
          </Button>,
          callback: () => {
            if (this.props.owner_tel_check_loading !== row.id) {
              this.props.owner_tel_checked(row.id)
            }
          }

        }]
      }



    } else if (column.key === "office_check_completed") {

      if (row.office_check_completed_at) {

        return [{
          icon: <div className="float-left" style={{ textAlign: "center", width: "60px", height: "100px", color: "#000000" }}> {row.office_check_completed === true ? <i className="fas fa-check" style={{ marginTop: "10px" }}></i> : new Date(row.office_check_completed_at).getMonth() + 1 + "/" + new Date(row.office_check_completed_at).getDate() + " " + row.office_check_completed_user_name}</div>,
          callback: () => {
            // if (this.props.energization_check_loading !== row.id) {
            this.props.completed_checked(row.id)

          }
        }]

      } else {
        return [{
          icon: <div className="float-left" style={{ textAlign: "center", width: "60px", height: "100px", color: "#ff0000" }}>{row.office_check_completed === true ? <i className="fas fa-check" style={{ marginTop: "10px" }}></i> : ""}</div>,
          callback: () => {
            // if (this.props.energization_check_loading !== row.id) {
            this.props.completed_checked(row.id)

          }
        }]
      }
    } else if (column.key === "cahnge_contents") {

      if (row.change_send_pm_flg === 0 && row.change_confirm_pm_at) {

        return [{
          icon: <Button
            color="primary"
            variant="outlined"
            size="small"
            type="submit"
            // disabled={this.props.energization_check_loading === row.id}
            style={{ margin: 2, minWidth: 0, width: 50, padding: 0, lineHeight: 2.4 }}
          // onClick={()=>this.add(12)}
          >

            {new Date(row.change_confirm_pm_at).getMonth() + 1 + "/" + new Date(row.change_confirm_pm_at).getDate() + " " + row.change_confirm_pm_user_name}

          </Button>,
          callback: () => {
            this.open_change(row)
          }

        }]

      } else if (row.change_send_pm_flg === 1) {
        return [{
          icon: <Button
            color="secondary"
            variant="contained"
            size="small"
            type="submit"
            // disabled={this.props.owner_tel_check_loading === row.id}
            style={{ margin: 2, minWidth: 0, width: 50 }}
          // onClick={()=>this.add(12)}
          ><UpdateIcon />
          </Button>, callback: () => {
            // if (this.props.energization_check_loading !== row.id) {
            this.open_change(row)

          }
        }]
      }


    }
    // else if (column.key === "net" && row.net === null) {
    //   return [{
    //     icon: ,
    //     callback: () => {


    //     }

    //   }]



    // }



  }



  getRowCount() {
    let count = this.props.rent_contracts_check_list.length;
    if (this.state.refresh && count > 0) {
      count--; // hack for update data-grid
      this.setState({
        refresh: false
      });
    }

    return count;
  }

  _onColumnResizeEndCallback(newColumnWidth: number, columnKey: string) {
    this.setState(({ columnWidths }) => ({
      columnWidths: {
        ...columnWidths,
        [columnKey]: newColumnWidth,
      },
    }));
  }

  render() {

    return (
      <div id="contractcheck">

        <ReactDataGrid
          // ref={node => this.grid = node}
          enableCellSelect={false}
          columns={this.state.columns}
          rowGetter={(i: number) => this.props.rent_contracts_check_list[i]}
          getCellActions={this.getCellActions}
          rowsCount={this.getRowCount()}
          headerRenderer={true}
          dragable={true}
          rowRenderer={RowRenderer}
          // onColumnResize={(idx, width) =>
          //     console.log(`Column ${idx} has been resized to ${width}`)
          // }
          // emptyRowsView={this.EmptyRowsView}
          // onRowClick={this.onRowClick}
          // rowSelection={{
          //     showCheckbox: true,
          //     enableShiftSelect: true,
          //     onRowsSelected: this.onRowsSelected,
          //     onRowsDeselected: this.onRowsDeselected,
          //     selectBy: {
          //       isSelectedKey: 'selected'
          //       // indexes: this.state.selectedIndexes
          //     }
          //   }}
          onGridSort={(sortColumn: any, sortDirection: any) => { this.sortRows(this.props.rent_contracts_check_list, sortColumn, sortDirection) }
            //
          }
          //onCellSelected={this.getSelectedCell}
          minHeight={600} />


        <Dialog onClose={this.close_change} aria-labelledby="customized-dialog-title" open={this.state.open_change_flg} maxWidth='xl'>
          <DialogTitle id="alert-dialog-title">{"変更履歴"}</DialogTitle>
          <DialogContent >


            <Table
              rowHeight={50}
              rowsCount={this.props.rent_contract_logs.length}
              width={900}
              height={600}
              headerHeight={50}
              onColumnResizeEndCallback={this._onColumnResizeEndCallback}
            >
              <Column isResizable={true} width={this.state.columnWidths.column1} columnKey="column1" header={<Cell style={{ whiteSpace: "nowrap" }}>変更</Cell>} cell={({ rowIndex, ...props }) => (<Cell {...props} style={{ whiteSpace: "nowrap" }}>{this.props.rent_contract_logs[rowIndex].change_contents}</Cell>)} />
              <Column isResizable={true} width={this.state.columnWidths.column2} columnKey="column2" header={<Cell style={{ whiteSpace: "nowrap" }}>更新日</Cell>} cell={({ rowIndex, ...props }) => (<Cell {...props} style={{ whiteSpace: "nowrap" }}>{this.props.rent_contract_logs[rowIndex].updated_at}</Cell>)} />
              <Column isResizable={true} width={this.state.columnWidths.column3} columnKey="column3" header={<Cell style={{ whiteSpace: "nowrap" }}>担当</Cell>} cell={({ rowIndex, ...props }) => (<Cell {...props} style={{ whiteSpace: "nowrap" }}>{this.props.rent_contract_logs[rowIndex].nickname}</Cell>)} />

              {/* {this.props.rent_contract_logs.map(function (value: any, i: any) {
                return <Column
                  columnKey={value.key_name}
                  width={200}
                  header={value.key_name}
                  // header={<SortHeaderCell
                  //   onSortChange={this._onSortChange}
                  //   sortDir={this.state.colSortDirs[value.key_name]}
                  //   style={{ whiteSpace: "nowrap" }}>{value.name}</SortHeaderCell>}

                  // cell={({ rowIndex, ...props }) => (<Cell style={{ whiteSpace: "nowrap" }} >{this.props.seisan_follow_list[rowIndex][value.key]}</Cell>)}
                  cell={({ rowIndex, ...props }) => (<Cell>{value.key_name}{value.nickname}</Cell>)}
                />
                // <Column
                //   header={<Cell>Col 1</Cell>}
                //   cell={<Cell>Column 1 static content</Cell>}
                //   width={2000}
                // />
                // <Column
                //   header={<Cell>Col 2</Cell>}
                //   cell={<MyCustomCell mySpecialProp="column2" />}
                //   width={1000}
                // />
                // <Column
                //   header={<Cell>Col 3</Cell>}
                //   cell={({ rowIndex, ...props }) => (
                //     <Cell {...props}>
                //       Data for column 3: {rows[rowIndex]}
                //     </Cell>
                //   )}
                //   width={2000}
                // />
              })} */}
            </Table>
          </DialogContent>
          <DialogActions>
            {this.state.confirm ? <Button onClick={() => this.check_rent_contract_logs_set(this.state.rent_contract_id)} color="primary">
              確認
            </Button> : ""}
            <Button onClick={this.close_change} color="primary" autoFocus>
              閉じる
            </Button>
          </DialogActions>
          {/* <DialogTitle id="simple-dialog-title">Set backup account</DialogTitle>
          <List>
            {emails.map((email) => (
              <ListItem button onClick={() => handleListItemClick(email)} key={email}>
                <ListItemAvatar>
                  <Avatar className={classes.avatar}>
                    <PersonIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={email} />
              </ListItem>
            ))}

            <ListItem autoFocus button onClick={() => handleListItemClick('addAccount')}>
              <ListItemAvatar>
                <Avatar>
                  <AddIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="Add account" />
            </ListItem>
          </List> */}
        </Dialog>
      </div >
    );
  }


}


const mapStateToProps = (state: any) => {
  return {
    user_details: state.masterReducer.user_details,
    shops: state.masterReducer.shops,
    rent_contracts_check_list: state.ContractCheck.rent_contracts_check_list,
    parking_check_loading: state.ContractCheck.parking_check_loading,
    energization_check_loading: state.ContractCheck.energization_check_loading,
    net_check_loading: state.ContractCheck.net_check_loading,
    electronics_check_loading: state.ContractCheck.electronics_check_loading,
    wifi_check_loading: state.ContractCheck.wifi_check_loading,
    autolock_check_loading: state.ContractCheck.autolock_check_loading,
    owner_tel_check_loading: state.ContractCheck.owner_tel_check_loading,
    rent_contract_logs: state.ContractCheck.rent_contract_logs,
  }
}
function mapDispatchToProps(dispatch: any) {
  return {

    parking_checked(state: any) {
      dispatch(ContractCheck.parking_checked(state))
    },
    energization_checked(state: any) {
      dispatch(ContractCheck.energization_checked(state))
    },
    net_checked(state: any) {
      dispatch(ContractCheck.net_checked(state))
    },
    electronics_checked(state: any) {
      dispatch(ContractCheck.electronics_checked(state))
    },
    wifi_checked(state: any) {
      dispatch(ContractCheck.wifi_checked(state))
    },
    autolock_checked(state: any) {
      dispatch(ContractCheck.autolock_checked(state))
    },
    completed_checked(state: any) {
      dispatch(ContractCheck.completed_checked(state))
    },

    owner_tel_checked(state: any) {
      dispatch(ContractCheck.owner_tel_checked(state))
    },
    get_rent_contract_logs(state: any) {
      dispatch(ContractCheck.get_rent_contract_logs(state))
    },
    check_rent_contract_logs(state: any) {
      dispatch(ContractCheck.check_rent_contract_logs(state))
    },
    // bind_kyousai_contract(state: any) {
    //   dispatch(ContractSearch.bind_kyousai_contract(state))
    // },
    //   get_banks(state:any) {
    //     dispatch(Kyousai.get_banks(state))
    // },

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountingGridComponent);
